import { NgModule } from '@angular/core';
import { SafeHtmlPipe } from './safe-html.pipe';
import { FileSizePipe } from './file-size.pipe';

@NgModule({
  imports: [],
  exports: [FileSizePipe, SafeHtmlPipe],
  declarations: [FileSizePipe, SafeHtmlPipe],
})
export class CustomPipesModule { }
